var _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _path7, _rect3, _path8, _rect4, _path9, _rect5, _rect6, _path10, _path11, _rect7, _path12, _path13, _rect8, _rect9, _path14, _path15, _rect10, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 364,
    viewBox: "0 0 378 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M199.047 321.712C199.047 321.712 178.063 263.197 76.5536 280.954C-13.5965 296.726 -5.56768 184.444 19.8744 144.738C52.8324 93.3037 136.003 89.1388 130.519 37.6878C125.034 -13.7632 242.98 -16.0197 255.714 60.6981C271.554 156.132 318.063 117.26 349.303 137.605C371.725 152.206 381.449 237.851 323.35 259.022C274.46 276.837 281.182 297.693 280.211 314.275C278.81 338.189 224.294 370.072 199.047 321.712Z",
    fill: "#E0E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.288 272.701L212.219 212.406L200.127 224.634L261.195 284.929L273.288 272.701Z",
    fill: "#71D0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.616 288.902L249.104 241.992C248.84 241.731 248.414 241.734 248.152 241.998L230.169 260.182C229.908 260.447 229.911 260.873 230.175 261.134L277.687 308.044C277.951 308.305 278.377 308.302 278.639 308.038L296.622 289.854C296.883 289.59 296.88 289.164 296.616 288.902Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.094 242.73C200.107 242.73 234.166 208.699 234.166 166.719C234.166 124.74 200.107 90.7086 158.094 90.7086C116.081 90.7086 82.0225 124.74 82.0225 166.719C82.0225 208.699 116.081 242.73 158.094 242.73Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.094 230.327C193.252 230.327 221.753 201.849 221.753 166.719C221.753 131.59 193.252 103.111 158.094 103.111C122.936 103.111 94.4351 131.59 94.4351 166.719C94.4351 201.849 122.936 230.327 158.094 230.327Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.449061,
    y: 0.120325,
    width: 33.4418,
    height: 11.7374,
    rx: 4.92932,
    transform: "matrix(0.866199 -0.499699 0.500301 0.865851 285.372 198.981)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.287 203.128C286.925 200.771 287.733 197.758 290.091 196.397L300.137 190.601L306.01 200.764L295.963 206.56C293.605 207.921 290.589 207.112 289.227 204.755L288.287 203.128Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 333.877,
    y: 207.705,
    width: 33.4487,
    height: 11.735,
    rx: 4.92932,
    transform: "rotate(-180 333.877 207.705)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.877 202.776C333.877 205.499 331.67 207.705 328.947 207.705L317.345 207.705L317.345 195.971L328.947 195.971C331.67 195.971 333.877 198.177 333.877 200.9L333.877 202.776Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.449061,
    y: 0.120326,
    width: 33.4418,
    height: 11.7374,
    rx: 4.92932,
    transform: "matrix(0.866199 -0.499699 0.500301 0.865851 -0.00011434 198.981)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91521 203.128C1.55319 200.771 2.3607 197.758 4.71883 196.397L14.7656 190.601L20.6378 200.764L10.5911 206.56C8.23296 207.921 5.21719 207.112 3.85518 204.755L2.91521 203.128Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5049,
    y: 207.705,
    width: 33.4487,
    height: 11.735,
    rx: 4.92932,
    transform: "rotate(-180 48.5049 207.705)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5049 202.776C48.5049 205.499 46.2979 207.705 43.5756 207.705L31.9735 207.705L31.9735 195.971L43.5756 195.971C46.2979 195.971 48.5049 198.177 48.5049 200.9L48.5049 202.776Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.657242
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.369067,
    y: 0.223196,
    width: 36.0596,
    height: 39.6394,
    rx: 4.57341,
    transform: "matrix(0.971052 -0.23887 0.239426 0.970915 119.238 293.831)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 23.0085,
    height: 22.9997,
    rx: 4.8783,
    transform: "matrix(0.971052 -0.23887 0.239427 0.970914 127.629 300.565)",
    fill: "#E0E8F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.178 303.4L142.93 314.564",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.14 307.607L135.968 310.357",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.369062,
    y: 0.223192,
    width: 31.0296,
    height: 10.8917,
    rx: 4.57341,
    transform: "matrix(0.971048 -0.238885 0.239412 0.970918 117.893 279.363)",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.826 284.249L146.514 287.04",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.274 289.06L126.962 291.851",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.120334,
    y: 0.413878,
    width: 36.0539,
    height: 39.6457,
    rx: 4.57341,
    transform: "matrix(0.876593 0.481232 -0.481919 0.876216 216.809 13.272)",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 23.0049,
    height: 23.0034,
    rx: 4.8783,
    transform: "matrix(0.876593 0.481232 -0.481919 0.876216 218.11 23.9504)",
    fill: "#E0E8F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.42 34.5256L219.879 44.602",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.692 42.3323L217.607 36.7954",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.120335,
    y: 0.413882,
    width: 31.0247,
    height: 10.8931,
    rx: 4.57341,
    transform: "matrix(0.876588 0.481242 -0.481909 0.876221 225.624 1.71463)",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242.556 24.2556L241.171 26.7747",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.908 14.5661L223.523 17.0852",
    stroke: "currentColor",
    strokeWidth: 0.609788
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundSearch);
export default __webpack_public_path__ + "static/media/NotFoundSearch.95b7939d.svg";
export { ForwardRef as ReactComponent };